const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_TASK_API_ORIGIN ||
  'https://fundswalla.in';

/** PAN / Aadhaar OTP → https://fundswalla.in/loan_backend/ */
export const loanBackendUrl = (endpoint) =>
  `${API_ORIGIN}/loan_backend/${String(endpoint).replace(/^\//, '')}`;

/** Absolute TaskApi URL on fundswalla.in */
export const taskApiDirectUrl = (endpoint) =>
  `${API_ORIGIN}/Api/TaskApi/${String(endpoint).replace(/^\//, '')}`;

/** Always absolute fundswalla.in TaskApi (same as existing apply-now) */
export const taskApiPostUrl = (endpoint) => taskApiDirectUrl(endpoint);

/** Lead save: https://fundswalla.in/Api/TaskApi/saveLendingPage */
export const saveLendingPageUrl = () => taskApiDirectUrl('saveLendingPage');

export const formatApiMessage = (message) => {
  if (typeof message !== 'string') return 'Something went wrong. Please try again.';
  return message.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '').trim();
};

/** Normalize success from TaskApi or loan_backend save responses */
export const isLeadSaveSuccess = (data) => {
  if (!data || typeof data !== 'object') return false;
  if (data.Status === 1 || data.status === 1) return true;
  if (data.success === true) return true;
  return false;
};

export const getLeadSaveMessage = (data, fallback = 'Something went wrong. Please try again.') =>
  formatApiMessage(data?.Message || data?.message || data?.error || fallback);

export const getLeadInsertedId = (data) =>
  data?.inserted_id || data?.insertedId || data?.Data?.inserted_id || data?.id || null;
